export const SINGLE_BRACKET_INTERPOLATION_OPTION = {
  prefix: '{',
  suffix: '}'
};
